export interface TemplateVariable {
  variable: string;
  description: string;
}

export const TEMPLATE_VARIABLES: Record<string, TemplateVariable[]> = {
  candidate_report: [
    { variable: "candidate_name", description: "Full name of the candidate" },
    { variable: "current_role", description: "Current job title" },
    { variable: "current_company", description: "Current employer" },
    { variable: "overall_score", description: "Assessment score (e.g. 8.5/10)" },
    {
      variable: "recommendation",
      description: "Score band (Missing requirements, Meets requirements, Exceeds requirements)",
    },
    { variable: "summary", description: "Overall assessment summary text" },
    { variable: "competency_scores", description: "Markdown table of competency dimension scores" },
    { variable: "generated_date", description: "Report generation date" },
  ],
  shortlist_report: [
    { variable: "campaign_title", description: "Title of the campaign" },
    { variable: "generated_date", description: "Report generation date" },
    { variable: "candidate_count", description: "Number of candidates in the shortlist" },
    { variable: "candidates_summary", description: "Summary table of all candidates" },
    { variable: "competency_comparison", description: "Comparison table of candidate scores" },
    { variable: "candidate_details", description: "Detailed profiles for each candidate" },
  ],
};
